<template lang="pug">
div.goal-icon( :style="{background: returnBackgroungColor(title), height: height + 'px', minWidth: width + 'px'}" )
  img( :src="require(`@/assets/goalIcon/${returnGoalIcon(title)}`)")
</template>

<script>
export default {
  name: 'GoalIcon',
  props: {
    title: null,
    height: {
      type: Number,
      default: 48
    },
    width: {
      type: Number,
      default: 48
    }
  },

  methods: {
    returnBackgroungColor(title) {
      switch(title) {
        case "Велосипед":
          return "linear-gradient(135deg, #FD9F01 0%, #F6514C 70.71%)"
        case "Nintendo Switch":
          return "linear-gradient(135deg, #01ADE4 0%, #2563EB 70.71%)"
        case "Курс":
          return "linear-gradient(90deg, #C084FC 0%, #F472B6 100%)"
        case "Наушники":
          return "linear-gradient(90deg, #60A5FA 0%, #22D3EE 100%)"
        case "Коньки":
          return "linear-gradient(90deg, #4ADE80 0%, #34D399 100%)"
        default:
          return "linear-gradient(135deg, #01ADE4 0%, #2563EB 70.71%)"
      }
    },

    returnGoalIcon(title) {
      switch(title) {
        case "Велосипед":
          return "bike.svg"
        case "Nintendo Switch":
          return "nintendo.svg"
        case "Курс":
          return "course.svg"
        case "Наушники":
          return "headphones.svg"
        case "Коньки":
          return "skates.svg"
        default:
          return "nintendo.svg"
      }
    }
  }
}
</script>
<style scoped>
.goal-icon {
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center; 
  border-radius: 12px;
}
</style>
